import { NEW_OUTFIT_BEHAVIOUR } from 'feature-flags';
import React from 'react';
import { Feature } from 'flagged';

import { CHANGEABLE_CATEGORIES } from 'constants/outfits';
import ProfileContext from 'components/Profile/ProfileContext';
import { OutfitSlotName } from 'types/outfit';
import { IQuality } from 'types/qualities';
import ProfileInventoryItemComponent from './ProfileInventoryItemComponent';

export default function ProfileInventoryItemContainer({ data }: { data: IQuality }) {
  const { category } = data;
  return (
    <Feature name={NEW_OUTFIT_BEHAVIOUR}>
      {(isEnabled: boolean) => (
        <ProfileContext.Consumer>
          {({ editable, profileCharacter }) => (
            <ProfileInventoryItemComponent
              data={data}
              editable={editable && CHANGEABLE_CATEGORIES.indexOf(category as OutfitSlotName) >= 0}
              hasNewOutfitBehaviour={isEnabled}
              profileCharacter={profileCharacter}
            />
          )}
        </ProfileContext.Consumer>
      )}
    </Feature>
  );
}

ProfileInventoryItemContainer.displayName = 'ProfileInventoryItemContainer';
